// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oh-1";
export var messageSideRight = "_oh-2";
export var subscribeToBackInStockBubbleContainer = "_oh-0";